<!-- 质保金支付申请表 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-bind:disabled="isDisabled" v-on:click='submit' size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'

	import {
		initWxConfig
	} from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate
	} from '@/api/approval'

	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'
import {
		formatDate
	} from '@/utils/date'
	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				"templateData": templateData,
				asd: 123,
				flowId: null
			}
		},
		mounted() { //页面挂载
			initWxConfig(this);
			this.getTemplate();
			stringUtils.setAddIsShow(false);
			this.spNo = this.$route.query.spNo;
		},
		created() {},
		methods: { //方法

			// getDepartmentDetailInfo: async function(deptId) {
			// 	var departName = "";
			// 	await getDepartmentInfo(deptId).then(res => {
			// 		departName = res.Body.FullName;
			// 	});
			// 	return departName;
			// },
			getTemplate: async function() {
				let that = this;
				console.log(this.$configure.logInfo);

				// console.log(stringUtils.GetQueryString("templateId"))
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async (res) => {

					var controls = res.data.Body;
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}

					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "行政主任") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
							let item = that.templateData.TemplateContent.Controls[i]
							item.Values = [];
							getDepartmentRelationByName(logInfo.fullName, false).then(async response => {
								if (response.Body != null && response.Body.length > 0) {
									item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "行政主任");

								}
								if (item.Values == null || item.Values[0] == null || item.Values[0][1] == "卢华") {
									item.Values = [];
									item.Values.push(that.$store.state.defaultMember);
								}
							});
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "大区董事") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
							let item = that.templateData.TemplateContent.Controls[i]
							item.Values = [];
							getDepartmentRelationByName(logInfo.fullName, true).then(async response => {
								if (response.Body != null && response.Body.length > 0) {
									item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "大区董事");
								}
								if (item.Values == null || item.Values[0] == null || item.Values[0][1] == "卢华") {
									item.Values = [];
									item.Values.push(that.$store.state.defaultMember);
								}
							});
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "大区总经理") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
							let item = that.templateData.TemplateContent.Controls[i]
							item.Values = [];
							getDepartmentRelationByName(logInfo.fullName, true).then(async response => {
								if (response.Body != null && response.Body.length > 0) {
									item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "总经理");
								}
								if (item.Values == null || item.Values[0] == null || item.Values[0][1] == "卢华") {
									item.Values = [];
									item.Values.push(that.$store.state.defaultMember);
								}
							});
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = "0";
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门总经理") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
							let item = that.templateData.TemplateContent.Controls[i]
							item.Values = [];
							getDepartmentRelationByName(logInfo.fullName, true).then(async response => {
								if (response.Body != null && response.Body.length > 0) {
									item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "总经理");
									if (item != null || item[0][1] == "卢华") {
										item.Values = [];
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							});
						}
					}

					this.listLoading = false;
					if (logInfo.fullName.indexOf("房友圈") == -1 &&
						logInfo.fullName.indexOf("工商铺") == -1 &&
						logInfo.fullName.indexOf("住宅部") == -1
					) {
						this.Message({
							message: '没有申请权限',
							type: 'error',
							duration: 1000
						});
						this.isDisabled = true;
					}
					this.templateData = this.assignControl(controls, logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
				}, err => {
					console.log(err)
				});
			},
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values = [];
						dataVal.Value = depart.name;
						dataVal.Values.push([depart.id, depart.name]);
						getDepartmentInfo(depart.id).then(async res => {
							var departFullName = res.Body.FullName;
							var departName = departFullName.split("/");
							that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
								if (logInfo.fullName.indexOf("住宅行政支持组") > -1 || logInfo.fullName.indexOf("住宅部") > -1 || logInfo.fullName
									.indexOf("住宅部支援中心") > -1) {
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values = [];
										item.Values = await that.getDepartmentRelation(depart.id, "行政主任");
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(that.$store.state.defaultMember);
										}
									}
									if (item.Property.Title[0].Text == "大区董事") {
										item.Values = [];
										//营业了为true
										item.Values = await that.getDepartmentRelation(depart.id, "大区董事", true);
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(that.$store.state.defaultMember);
										}
									}
									if (item.Property.Title[0].Text == "大区总经理") {
										item.Values = [];
										item.Values = await that.getDepartmentRelation(depart.id, "总经理", true);
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(that.$store.state.defaultMember);
										}
									}
									}
							})
						})
					}

				})
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val, name) {
				console.log(val);
				console.log(name);

			},
			submit() {
				let that = this;
				var controls = that.templateData.TemplateContent.Controls;
				for (var i = 0; i < controls.length; i++) {
					if (controls[i].Property != null && controls[i].Property.Require == 1 && ((controls[i].Value == null || controls[i]
							.Value == '') && (controls[i].Values == null || controls[i].Values == ''))) {
						that.$message.error(controls[i].Property.Title[0].Text + "未填写,请填写完整");
						isSubmit = false;
						return;
					}
					if (controls[i].Property.Title[0].Text == "流程条件") {
						if (controls[i].Value == -1) {
							that.$message.error("没有申请权限");
							return;
						}
					}
				}
				if (isSubmit) {
					that.$message.info("已提交");
					return;
				}

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "申请类型"
				})[0];
				var control1Text = control1.Config.Selector.Options.filter(t => {
					return t.Key == control1.Value
				})[0].Value[0].Text;
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请类型：" + control1Text + "申请",
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "申请内容及备注"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "内容：" + control3.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var data = new Date();
				var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				var dateTime = data.getFullYear() + "-" + month + "-" + date;

				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请时间：" + dateTime,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				this.templateData.SummaryList = SummaryList;


				isSubmit = true;

				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
